import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const type = getCurrentTypePreference()
    setTimeout(() => {
      this.dispatch("changed", { detail: { type: type }, bubbles: true })
    }, 0);
  }
  paper() {
    this.dispatch("changed", { detail: { type: "paper" } })
    this.#updateHash("paper")
  }

  online() {
    this.dispatch("changed", { detail: { type: "online" } })
    this.#updateHash("online")
  }

  arena() {
    this.dispatch("changed", { detail: { type: "arena" } })
    this.#updateHash("arena")
  }

  #updateHash(type) {
    if (history.pushState) history.pushState(null, null, "#" + type)
    else window.location.hash = type
  }
}
